module.exports = __webpack_public_path__ + "static/IMG_3592-c4d4e522891b8b53cd766eb60fd0c560.jpg";